module.exports = __webpack_public_path__ + "img/defai.ae89ba58.png";